import React, { Component } from 'react';
import List from '../List';
import styled from 'styled-components';

interface Props {
  assignPredSearchQues: any;
  indexOfPredSearchElem: number;
  changeCursor: Function;
  predList: any;
}

const PredBox = styled.div`
  border-bottom: 1px solid
    ${(props: any) => {
      return props.foreground + '33';
    }};
`;

const styleVars = getComputedStyle(document.querySelector(':root'));

class InputSuggestions extends Component<Props, null> {
  changeCursor = (type, item) => {
    let list = this.props.predList;
    this.props.changeCursor(type, item, list);
  };

  render() {
    let foreground = styleVars.getPropertyValue('--inputBoxColor') || '#000000';
    return this.props.predList.length > 0 ? (
      <PredBox
        {...{ foreground: foreground }}
        className="auto-suggestions-block no-scroll"
      >
        {/* {this.props.predSearchResponse ? ( */}
        <List
          items={this.props.predList}
          changeCursor={this.changeCursor}
          onPress={this.props.assignPredSearchQues}
          listElement={this.props.indexOfPredSearchElem}
        />
        {/* ) : null} */}
      </PredBox>
    ) : (
      ''
    );
  }
}
export default InputSuggestions;
